'use strict';

bbw.directive.bbwFocusOn = ['$rootScope', function($rootScope) {
    return {
        restrict: 'A',
        scope: {
            'eventName': '=bbwFocusOn'
        },
        link: function(scope, element) {
            var el = element[0];
            $rootScope.$on(scope.eventName, function() {
                el.focus();
            });
        }
    };
}];
